import React from 'react';

import BEMHelper from '@ynap/bem-helper';

import { LoyaltyCustomerCareProps } from './types';

const bem = new BEMHelper('LoyaltyCustomerCare');

const LoyaltyCustomerCare = ({ locale, messages, className, tier = 'guest' }: LoyaltyCustomerCareProps) => {
    const infoMessage = messages?.loyalty?.customerCare?.infoMessage({ tier });
    const contactLink = messages?.loyalty?.customerCare?.contactLink({ tier });

    return infoMessage && contactLink ? (
        <div className={bem(null, tier, className)}>
            <div className={bem('content')}>
                <div className={bem('infoMessage')}>{infoMessage}</div>
                <a href={`/${locale.id}/content/help/contact-us/`} className={bem('contactLink')} target="_blank" rel="noopener noreferrer">
                    {contactLink}
                </a>
            </div>
        </div>
    ) : null;
};

LoyaltyCustomerCare.layoutVariant = 'isc-loyalty-customer-care';

export default LoyaltyCustomerCare;
